import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import * as _moment from 'moment-timezone';

import { deepClone } from '@recruitee/utils';

const moment = _moment;

@Component({
  selector: 'rt-time-zone-picker-dropdown-list',
  templateUrl: './time-zone-picker-dropdown-list.component.html',
  styleUrls: ['./time-zone-picker-dropdown-list.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeZonePickerDropdownListComponent {
  @Input() public dark: boolean = false;

  @Output() public zoneSelect: EventEmitter<string> = new EventEmitter();

  @ViewChild('searchInput', { static: true }) public searchInput: any;

  public filteredZones: string[];
  public isEmpty: boolean = true;

  private timeZonesList: string[];

  constructor(protected cdRef: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.timeZonesList = moment.tz.names();
    this.filteredZones = deepClone(this.timeZonesList);
    this.cdRef.detectChanges();
  }

  public onInputChange(event: any): void {
    this.searchInput.setValue(event.target.value);
    this.isEmpty = event.target.value.length === 0;
    const query = event.target.value;
    this.filteredZones = this.timeZonesList.filter(zone =>
      zone.toLowerCase().includes(query.toLowerCase()),
    );
    this.cdRef.detectChanges();
  }

  public clearField(): void {
    this.searchInput.input.nativeElement.value = '';
    this.searchInput.setValue('');
    this.filteredZones = deepClone(this.timeZonesList);
    this.cdRef.detectChanges();
  }

  public trackByZone(index: number, timezone: string): string {
    return timezone;
  }
}
